import { useQuery } from "@tanstack/react-query";

import { infoOptions } from "@/openapi/@tanstack/react-query.gen";

export const useAppInfo = () => {
  return useQuery(infoOptions());
};
